<template>
    <c-dialog
            ref="dialog"
            :title="editFlag ? '编辑流程' : '新建流程'"
            width="500"
            mode="slide"
            @resolve="submitHandle"
    >
        <c-form ref="form" column="1" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="流程名称" required>
                <c-input name="processName" placeholder="请输入流程名称"></c-input>
            </c-form-item>

            <c-form-item label="所属对象" required>
                <c-select name="objectModelId" async @search="searchObjectModel" :value-data="selectedObjectModel"></c-select>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            editFlag: false,
            currentData: null,
            selectedObjectModel: []
        }
    },

    methods: {
        open(data) {
            this.currentData = data;
            this.editFlag = !!data;

            this.$refs.form.clear();

            if (data) {
                this.selectedObjectModel = [
                    {
                        name: data.objectModelName,
                        value: data.objectModelId
                    }
                ];
                this.$refs.form.set(data);
            }

            this.$refs.dialog.open();
        },

        submitHandle(stop, next) {
            stop();

            this.$refs.form.submit({
                url: this.editFlag ? '/flow/workflow/edit' : '/flow/workflow/add',
                rule: {
                    processName: '请填写流程名称',
                    objectModelId: '请选择所属对象'
                },
                dataFormatter: (data) => {
                    // 如果是编辑，保留原ID
                    if (this.editFlag && this.currentData) {
                        data.processId = this.currentData.id;
                    }
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: this.editFlag ? '编辑成功' : '创建成功',
                        type: 'success'
                    });
                    this.$emit('resolve', res);
                },
                error: (error) => {
                    console.error('保存失败:', error);
                    this.$message({
                        message: error.message || '保存失败，请重试',
                        type: 'error'
                    });
                }
            });
        },
        /*******搜索对象*****************/
        searchObjectModel(keyword, resolve){
            this.request({
                url:'/flow/workflow/object_model/list',
                data: {

                },
                success:data => {
                    var newData = [];
                    for(var i=0;i<data.length;i++){
                        newData.push({
                            name:data[i].objectModelName,
                            value:data[i].id
                        });
                    }
                    resolve(newData);
                }
            })
        },
    },
}
</script>

<style lang="stylus" scoped>
</style>
